import React from "react";
import DefaultLayout from "./DefaultLayout";
import Loading from "../components/Loading";
import { connect } from "react-redux";
import "./PrintStyle.css";

const COLORS = ["#0072A7", "#57B5E1", "#80d9ff"];

export class NumberHorizontalLayout extends DefaultLayout {
  render() {
    const { metric, index } = this.props;
    const { data, isLoading } = this.state;
    return (
      <div className="w-100 row m-0">
        <div
          className="col-xs-12 col-md-2 d-flex justify-content-center align-items-center text-center font-weight-bold"
          style={{ color: COLORS[index % COLORS.length] }}
        >
          {isLoading ? (
            <Loading />
          ) : (
            <div className="text-center p-3" style={{ fontSize: "2.5em" }}>
              {data}
            </div>
          )}
        </div>
        <div
          className="p-3 col-md-10"
          style={{
            color: "white",
            backgroundColor: COLORS[index % COLORS.length],
          }}
        >
          <div className="text-align-left title">{metric.title}</div>
          <div className="text-align-left description">
            {metric.description}
          </div>
        </div>
      </div>
    );
  }
}

function mapStateToProps(state, ownProps) {
  return {
    ...ownProps,
    group_ids: state.filters.group_ids,
    resident_id: state.filters.resident_id,
    filter_by_resident: state.filters.filter_by_resident,
    group_categories: state.filters.group_categories,
    resident_statuses: state.filters.resident_statuses,
    start_date: state.filters.start_date,
    end_date: state.filters.end_date,
    isLoading: true,
    processing: true,
  };
}

export default connect(mapStateToProps)(NumberHorizontalLayout);
